import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b4vrxv58sb: FaireBrandEntity = {
  token: "b_b4vrxv58sb",
  type: "brand",
  name: "Blue Sky Clothing Co LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/3898670fcad533e9f076e0e0d3d67dc2b91b4b060b8983ffa759c43ea5876ac3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c7027809df29e4d4d2f6b84a6f4e74e5cfc6996a28fed52145a64ce03ebf9c38.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3898670fcad533e9f076e0e0d3d67dc2b91b4b060b8983ffa759c43ea5876ac3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c7027809df29e4d4d2f6b84a6f4e74e5cfc6996a28fed52145a64ce03ebf9c38.png",
  location: "North Vancouver, BC, CAN",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 68,
  isInsider: false,
  description:
    "Blue Sky offers clothing that fits all shapes and sizes. Everyone wants to feel beautiful and comfortable so there’s a great amount of detail given to the fit of each garment and there is a deep selection of categories and styles to choose from; with almost all available in sizes from XXS to 4X. We are as inclusive with our sizes and styles as we are with our pricing, as there is no additional charge for plus-size clothing; virtually unheard of in the industry, let alone in natural fabrics.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:15.248Z",
    importedBy: "entity-db-cli",
  },
};
